class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    document.dispatchEvent(new CustomEvent("cart:open", {
      detail: {
        message: 'cart-drawer opened',
      }
    }));
    
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
      BSS_B2B?.handleCartCheckoutBtn?.(BSS_B2B?.shopData)
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
      
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
    fetch('/cart.js')
            .then(response => response.json())
            .then(data => {
              
              var today_Date = new Date();
              var options = { 
                year: 'numeric', 
                month: 'long', 
                day: 'numeric', 
                timeZone: 'America/Los_Angeles' 
              };
              
                var formattedDate = today_Date.toLocaleDateString('en-US', options);
                var currentdate_formate = formattedDate;
                var giftproduct_alldata = giftproductdata[currentdate_formate];
                if(typeof giftproduct_alldata!=='undefined'){
                  var gift_start_date = new Date(giftproduct_alldata.giftpurchase_start_date);
                    var gift_current_date = new Date(currentdate_formate);
                    
                    var start_date_difference = Math.abs(gift_start_date - gift_current_date);
    
                    // Convert the difference to days
                    var start_daysDifference = Math.ceil(start_date_difference / (1000 * 60 * 60 * 24));
                    var gift_array = [];
                    var cart_product_array = [];
                    var giftproduct1 = parseInt(giftproduct_alldata.giftpurchase_product),
                     giftproduct2 = parseInt(giftproduct_alldata.giftpurchase_product2);
                    data.items.forEach(function(item) {
                      var item_id = item.id;
                      cart_product_array.push(item_id);
                    });
                    if(start_daysDifference == 0){
                      if(data.total_price > giftpurchase_amount){
                        if(giftproduct_alldata.giftpurchase_product != '' && giftproduct_alldata.giftpurchase_product2 != ''){
                          if ($.inArray(giftproduct1, cart_product_array) == -1 && $.inArray(giftproduct2, cart_product_array) == -1) {
                            gift_array.push(giftproduct_alldata.giftpurchase_product, giftproduct_alldata.giftpurchase_product2);
                            var productval = gift_array.shift();
                            giftpurchase_productadd(productval); 
                          }
                          else if ($.inArray(giftproduct1, cart_product_array) == -1 && $.inArray(giftproduct2, cart_product_array) == 1) {
                            giftpurchase_productadd(giftproduct1); 
                          } else if ($.inArray(giftproduct1, cart_product_array) == 1 && $.inArray(giftproduct2, cart_product_array) == -1) {
                            giftpurchase_productadd(giftproduct2); 
                          }
                        }else if(giftproduct_alldata.giftpurchase_product != '' && giftproduct_alldata.giftpurchase_product2 == ''){
                          if ($.inArray(giftproduct1, cart_product_array) == -1) {
                            giftpurchase_productadd(giftproduct1); 
                          } 
                        }else if(giftproduct_alldata.giftpurchase_product == '' && giftproduct_alldata.giftpurchase_product2 != ''){
                          if ($.inArray(giftproduct2, cart_product_array) == -1) {
                            giftpurchase_productadd(giftproduct12); 
                          } 
                        }

                        document.dispatchEvent(new CustomEvent("cart:updated", {
                          message: 'cart-drawer updated',
                          detail: parsedState
                        }));
                        
                        fetch('/cart.js')
                                .then(response => response.json())
                                .then(data => {
                                 calculateProgress(data.total_price, cart_shipping_amount); 
                                });
                      }else if(data.total_price < giftpurchase_amount || data.total_price == 0){
                        if(giftproduct_alldata.giftpurchase_product != '' && giftproduct_alldata.giftpurchase_product2 != ''){
                          if ($.inArray(giftproduct1, cart_product_array) <= 1 && $.inArray(giftproduct2, cart_product_array) <= 1) {
                            gift_array.push(giftproduct_alldata.giftpurchase_product, giftproduct_alldata.giftpurchase_product2);
                            var productval = gift_array.shift();
                            giftpurchase_productremove(productval); 
                          }
                          else if ($.inArray(giftproduct1, cart_product_array) <= 1 && $.inArray(giftproduct2, cart_product_array) == -1) {
                            giftpurchase_productremove(giftproduct1); 
                          } else if ($.inArray(giftproduct1, cart_product_array) == -1 && $.inArray(giftproduct2, cart_product_array) <= 1) {
                            giftpurchase_productremove(giftproduct2); 
                          }
                        }else if(giftproduct_alldata.giftpurchase_product != '' && giftproduct_alldata.giftpurchase_product2 == ''){
                          if ($.inArray(giftproduct1, cart_product_array) <= 1) {
                            giftpurchase_productremove(giftproduct1); 
                          } 
                        }else if(giftproduct_alldata.giftpurchase_product == '' && giftproduct_alldata.giftpurchase_product2 != ''){
                          if ($.inArray(giftproduct2, cart_product_array) <= 1) {
                            giftpurchase_productremove(giftproduct12); 
                          } 
                        }
                        fetch('/cart.js')
                                .then(response => response.json())
                                .then(data => {
                                 calculateProgress(data.total_price, cart_shipping_amount); 
                                });
                      }
                    }else{
                      calculateProgress(data.total_price, cart_shipping_amount); 
                    }
    
                    function giftpurchase_productadd(giftpurchase_product){
                      $.ajax({
                        type: 'POST',
                        url: '/cart/add.js',
                        data: {
                          quantity: 1,
                          id: giftpurchase_product,
                          properties: {
                            'Gift': 'FREE GIFT WITH PURCHASE'
                           }
                        },
                        dataType: 'json',
                        success: function(response) {
                          if(gift_array.length > 0){
                            var productval = gift_array.shift();
                            giftpurchase_productadd(productval); 
                          }else{
                            fetch('/cart.js')
                            .then(response => response.json())
                            .then(data => {
                             calculateProgress(data.total_price, cart_shipping_amount); 
                            });
                          
                            fetch(`${routes.cart_url}?section_id=cart-drawer`)
                              .then((response) => response.text())
                              .then((responseText) => {
                                const html = new DOMParser().parseFromString(responseText, 'text/html');
                                const cartDrawerhtml = html.querySelector('.cart-drawer');
                                document.querySelector('.cart-drawer').innerHTML = cartDrawerhtml.innerHTML;
                                const cartcounthtml = html.querySelector('.cartdrawer-count');
                                if(document.querySelector('.cart-count-bubble')){
                                  document.querySelector('.cart-count-bubble').innerHTML = cartcounthtml.innerHTML;
                                }else{
                                  document.querySelector('.header__icon--cart').innerHTML += '<div class="cart-count-bubble"><span aria-hidden="true">1</span></div>';
                                  document.querySelector('.cart-count-bubble').innerHTML = cartcounthtml.innerHTML;
                                }
                                document.querySelector('cart-drawer').classList.remove('is-empty');
                                
                              })
                              .catch((e) => {
                                console.error(e); 
                              });
                          }
                        },
                        error: function() {
                        }
                      });
                    }
    
                    function giftpurchase_productremove(giftpurchase_product){
                      // console.log(giftpurchase_product);
                      $.ajax({
                        type: 'POST',
                        url: '/cart/change.js',
                        data: {
                          quantity: 0,
                          id: giftpurchase_product
                        },
                        dataType: 'json',
                        success: function(response) {
                          if(gift_array.length > 0){
                            var productval = gift_array.shift();
                            giftpurchase_productremove(productval); 
                          }else{
                            fetch('/cart.js')
                            .then(response => response.json())
                            .then(data => {
                              calculateProgress(data.total_price, cart_shipping_amount); 
                            });
                          
                            fetch(`${routes.cart_url}?section_id=cart-drawer`)
                              .then((response) => response.text())
                              .then((responseText) => {
                                const html = new DOMParser().parseFromString(responseText, 'text/html');
                                const cartDrawerhtml = html.querySelector('.cart-drawer');
                                document.querySelector('.cart-drawer').innerHTML = cartDrawerhtml.innerHTML;
                                const cartcounthtml = html.querySelector('.cartdrawer-count');
                                if(document.querySelector('.cart-count-bubble')){
                                  document.querySelector('.cart-count-bubble').innerHTML = cartcounthtml.innerHTML;
                                }else{
                                  document.querySelector('.header__icon--cart').innerHTML += '<div class="cart-count-bubble"><span aria-hidden="true">1</span></div>';
                                  document.querySelector('.cart-count-bubble').innerHTML = cartcounthtml.innerHTML;
                                }
                                document.querySelector('cart-drawer').classList.remove('is-empty');
                                // console.log("fvvvvv")
                              })
                              .catch((e) => {
                                console.error(e); 
                              });
                          }
                        },
                        error: function() {
                        }
                      });
                    }
                }else{
                  fetch('/cart.js')
                    .then(response => response.json())
                    .then(data => {
                     calculateProgress(data.total_price, cart_shipping_amount); 
                    });
                }

            });
    if(!$('.cart-drawer--collectionproduct').hasClass('slick-initialized')){
      $('.cart-drawer--collectionproduct').slick({
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        responsive: [
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 390,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      }); 
    }

    $.getJSON('/cart.js', function(cartresult) {
      cartresult.items.forEach(function(item) {
        var item_id = item.id,
        item_property = item.properties['Type'];
        $('.block_bundle_info').each(function() {
          var bundle_cart_id = $(this).attr('data-id');
          if (bundle_cart_id == item_id && item_property == 'Bundle Product') {
            $(this).addClass('added-to-bundle');
          }
        });
      });
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);



